module.exports = __webpack_public_path__ + "711b43aa51af724827aefffda435e7f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/footer/ozco_larger.png
// module id = 862
// module chunks = 0